export default __webpack_public_path__ + "static/media/StaticHeader-WOE.ff35a508.png";